var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxGroupBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.604 11.048C17.213 10.0101 17.4761 8.80528 17.355 7.60797C17.176 5.82397 16.18 4.24697 14.552 3.16797L13.447 4.83397C14.566 5.57597 15.247 6.63297 15.365 7.80797C15.4194 8.35407 15.3514 8.90543 15.166 9.42195C14.9806 9.93847 14.6823 10.4072 14.293 10.794L13.101 11.986L14.719 12.461C18.951 13.701 19 17.957 19 18H21C21 16.211 20.044 12.715 16.604 11.048Z",
    fill: "#2E3BC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12C11.706 12 13.5 10.206 13.5 7.99997C13.5 5.79397 11.706 3.99997 9.5 3.99997C7.294 3.99997 5.5 5.79397 5.5 7.99997C5.5 10.206 7.294 12 9.5 12ZM9.5 5.99997C10.603 5.99997 11.5 6.89697 11.5 7.99997C11.5 9.10297 10.603 9.99997 9.5 9.99997C8.397 9.99997 7.5 9.10297 7.5 7.99997C7.5 6.89697 8.397 5.99997 9.5 5.99997ZM11 13H8C4.691 13 2 15.691 2 19V20H4V19C4 16.794 5.794 15 8 15H11C13.206 15 15 16.794 15 19V20H17V19C17 15.691 14.309 13 11 13Z",
    fill: "#2E3BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxGroupBlue);
export default __webpack_public_path__ + "static/media/bx-group-blue.22465551da2c1a9bd7313317ca5772ef.svg";
export { ForwardRef as ReactComponent };